import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from "@angular/core";
import { FormControl } from "@angular/forms";

import { Observable, Subscription } from "rxjs";
import { filter, map, startWith, pairwise } from "rxjs/operators";

import { UserService } from "@onsip/common/services/api/resources/user/user.service";
import { UserSummaryContactService } from "@onsip/common/services/api/resources/userSummaryContact/user-summary-contact.service";

@Component({
  selector: "onsip-team-member-form",
  templateUrl: "team-member.component.html",
  styleUrls: ["../organization.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TeamMemberComponent implements OnInit, OnDestroy {
  users!: Observable<
    Array<{
      id: string;
      name: string;
      avatarUrl: string;
    }>
  >;
  formControl = new FormControl();

  private unsubscriber = new Subscription();

  constructor(
    private userSummaryContact: UserSummaryContactService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.users = this.userSummaryContact.state.pipe(
      map(substate =>
        Object.values(substate.state)
          .sort((a, b) => (a.contactName?.toUpperCase() > b.contactName?.toUpperCase() ? 1 : -1))
          .map(user => ({
            name: user.contactName,
            id: user.userId,
            avatarUrl: user.userAvatarUrl
          }))
      )
    );
    this.unsubscriber.add(
      this.userSummaryContact.state
        .pipe(
          map(substate =>
            Object.values(substate.state)
              .filter(user => user.teamPageVisible)
              .sort((a, b) => (a.contactName.toUpperCase() > b.contactName.toUpperCase() ? 1 : -1))
          ),
          filter(users => users.length > 0)
        )
        .subscribe(users => {
          this.formControl.setValue(users.map(user => user.userId));
        })
    );

    this.unsubscriber.add(
      this.formControl.valueChanges
        .pipe(startWith(this.formControl.value), pairwise())
        .subscribe(([prev, next]: [Array<string> | null, Array<string>]) => {
          const additions = next.filter(nextId => !prev?.find(prevId => prevId === nextId));
          const removals = prev?.filter(prevId => !next.find(nextId => nextId === prevId)) || [];

          additions.forEach(userId => {
            this.userService.userEditTeamPageVisibility(userId, true);
          });
          removals.forEach(userId => {
            this.userService.userEditTeamPageVisibility(userId, false);
          });
        })
    );
  }

  ngOnDestroy() {
    this.unsubscriber.unsubscribe();
  }
}
